import React from 'react'

const OneManDelivery = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__one-man-delivery ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path d='M20.816 15A2.992 2.992 0 0 0 18 13a2.992 2.992 0 0 0-2.817 2H8.816A2.993 2.993 0 0 0 6 13a2.993 2.993 0 0 0-2.817 2H2V7h13.04c.303 0 .59.138.781.375l3.1 3.876a2 2 0 0 0 1.561.751h1.52V15h-1.186zM18 17a1 1 0 1 1 .001-2 1 1 0 0 1 0 2zM6 17a1 1 0 1 1 .001-2 1 1 0 0 1 0 2zm14.482-6.998l-3.1-3.876A3 3 0 0 0 15.04 5H1a1 1 0 0 0-1 1v10.004a1 1 0 0 0 1 1h1L3.183 17A2.993 2.993 0 0 0 6 19a2.993 2.993 0 0 0 2.816-2h6.367A2.992 2.992 0 0 0 18 19a2.992 2.992 0 0 0 2.816-2h1.186l.998.002a1 1 0 0 0 1.002-1v-4a2 2 0 0 0-2-2h-1.52z' />
  </svg>
)

export default OneManDelivery
